import { paymentSchema, type Payment, type UpdatePaymentBody } from '@klopotun/contracts';
import { apiRequest } from '../../../../shared/api/index.js';

const patchPayment = (id: string, body: UpdatePaymentBody): Promise<unknown> =>
  apiRequest<unknown>(`/payments/${id}`, { method: 'PATCH', body });

export const updatePayment = async (id: string, body: UpdatePaymentBody): Promise<Payment> =>
  paymentSchema.parse(await patchPayment(id, body));
